import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@mui/joy';

import { AppContext } from '@/shared/context/context';
import signalRMessages from '@/redux/actions/signalRMessages';
import useNotification from '@/shared/hooks/UseNotification';
import useSocketEvent from '@/shared/hooks/useSocketEvent';

import { OpenIcon } from '@/shared/icons/Icons';

const useGlobalBookYearClosingFinishedMessage = () => {
  const { setUi, currentTeamUser } = useContext(AppContext);
  const navigate = useNavigate();
  const { sendNotification } = useNotification();
  const { t } = useTranslation();

  useSocketEvent(signalRMessages.BookYearClosingFinished, (...args: string[]) => {
    const [
      homeownerAssociationId,
      homeownerAssociationName,
      bookYearId,
      bookYearDescription,
      userId,
    ] = args;

    if (userId !== currentTeamUser?.userId) return;

    const handleOpen = () => {
      setUi({ payload: bookYearId, type: 'SET_CURRENT_BOOK_YEAR_ID' });
      navigate(`/homeowner-association/${homeownerAssociationId}/accounting`);
    };

    sendNotification({
      header: t('success'),
      message: t('_closeBookYear.bookYearClosingFinished', {
        bookYear: bookYearDescription,
        homeownerAssociationName,
      }),
      options: {
        action: (
          <IconButton size="sm" onClick={handleOpen} className="text-white hover:bg-white/10">
            <OpenIcon />
          </IconButton>
        ),
        autoHideDuration: 10000,
      },
      variant: 'success',
    });
  });
};

export default useGlobalBookYearClosingFinishedMessage;
